import { useState } from "react";
import { PrimaryBtn } from "@/components/button/primary-button";

import styles from "./feedback.module.scss";

export default function Feedback({ handleSubmit }) {
  const MAX_LENGTH = 2000;

  const [text, setText] = useState("");
  // const [wordCount, setWordCount] = useState(0);
  const [feedback, setFeedback] = useState("");

  const handleChange = (e) => {
    const value = e.target.value;
    setText(value);
    // setWordCount(value ? value.trim().split(/\s+/).length : 0);
    if (value.length <= 2000) {
      setFeedback(() => e.target.value);
    }
  };

  return (
    <div className={styles["feedback-tab"]}>
      <h2 className={styles["heading"]}>Send us your feedback</h2>
      <div className={styles["feedback-section"]}>
        <h6 className={styles["sub-heading"]}>Comment/Questions/Suggestions</h6>
        <textarea
          id="user-feedback"
          value={text}
          className={styles["user-feedback"]}
          placeholder="Share your feedback..."
          rows="15"
          cols="150"
          maxLength={MAX_LENGTH}
          onChange={(e) => handleChange(e)}
        ></textarea>
        <div
          className={styles["word-count"]}
        >{`${feedback.length} / ${MAX_LENGTH}`}</div>
      </div>
      <button
        className={`${styles["feedback-btn"]}  btn btn-primary admy-primary-btn d-flex align-items-center`}
        onClick={() => {
          if (feedback.length > 0) {
            handleSubmit(feedback);
            setText("");
            setFeedback("");
          }
        }}
      >
        <svg
          className="me-1"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.0445 6.24193C18.6308 6.04649 19.1886 6.6043 18.9931 7.19062L14.168 21.666C13.9636 22.2791 13.1313 22.3639 12.8074 21.8046L9.46943 16.0389C9.40377 15.9255 9.30955 15.8313 9.19614 15.7656L3.43049 12.4276C2.87118 12.1038 2.95598 11.2714 3.5691 11.0671L18.0445 6.24193ZM4.71454 11.8711L17.6887 7.54637L13.364 20.5205L10.4841 15.5462L13.311 12.7194C13.5306 12.4997 13.5306 12.1435 13.311 11.9239C13.0913 11.7042 12.7351 11.7042 12.5155 11.9239L9.68856 14.7508L4.71454 11.8711Z"
            fill="white"
          />
        </svg>
        Submit
      </button>
    </div>
  );
}
